import { Badge as InnerBadge } from '@change/ds-core-ui/next';

import type { ItemPriceProps } from './ItemPrice.types';

export const Badge: React.FC<{
	position: 'top' | 'bottom';
	badge: ItemPriceProps['badge'];
	['data-testid']?: string;
}> = ({ position, badge, 'data-testid': dataTestId }) => {
	if (!badge) return null;
	if (position !== badge.position) return null;
	return (
		<div className="flex justify-start">
			<InnerBadge
				label={badge.label}
				size="small"
				variant="emphasized-dark"
				leadingIcon={badge.icon}
				data-testid={dataTestId}
			/>
		</div>
	);
};
